module.exports = __webpack_public_path__ + "img/idcardz.cd1ebef4.png";